<template>
  <div>
    <form-wizard
      ref="formWizard"
      :title="null"
      :subtitle="null"
      class="bg-white mb-1"
      step-size="xs"
      shape="circle"
      @on-complete="formSubmitted"
      @on-loading="setLoading"
    >
      <template #next>
        <b-button
          variant="primary"
        >
          Proximo
        </b-button>
      </template>

      <template #prev>
        <b-button
          variant="primary"
          hidden="hidden"
        >
          Voltar
        </b-button>
      </template>

      <template #finish>
        <b-button
          variant="primary"
        >
          {{ formIntegration.inteSelected.id != null ? 'Atualizar Integração' : 'Salvar Integração' }}
        </b-button>
      </template>
      <!-- Escolher o chat fluxo que vai ser monitorado -->
      <tab-content
        title="Para leads gerados nos fluxos"
        :before-change="validateAsync"
      >
        <b-row v-if="!loadingWizard">
          <b-col
            cols="12"
            class="mb-2"
          >

            <b-form-group>
              <v-select
                v-model="formIntegration.chatSelected"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="name"
                :reduce="chat => chat"
                :options="chatsExistents"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </tab-content>

      <!-- Configuração dos campos a ser mapeado do chat (@cpf pessoa) -->
      <tab-content
        title="Configurações"
        :before-change="validateAsync"
      >
        <b-col
          cols="12"
          class="mb-2 px-0"
        >
          <h5 class="mb-0">
            Pipedrive
          </h5>

          <small class="text-muted">Configure sua integração do Pipedrive</small>
        </b-col>
        <b-row v-if="!loadingWizard">
          <b-col
            v-for="(form, index) in formIntegration.formPipedriveConfig"
            :key="index"
            cols="12"
            class="mb-2"
          >
            <b-form-group>
              <div>
                <strong
                  v-if="form.id !== 'email'"
                  class="mb-5"
                >{{ form.title }}</strong>
                <strong
                  v-else-if="form.title !== ''"
                  class="mb-5"
                >{{ form.title }} <span style="color: red">*</span></strong>
              </div>

              <Info
                v-if="form.title !== ''"
                :id="`form_rd_${form.id}`"
                :message="form.value"
                :variaveis="variaveis"
                :is-tag-value="false"
                @atualizarMessage="atualizarValue($event, form)"
              />
            </b-form-group>
          </b-col>
          <b-col>
            <div class="form-group">
              <label for="pipedrive">Selecione um usuário do Pipedrive:</label>
              <select
                id="pipedrive"
                v-model="selectedUser"
                class="form-control"
                :disabled="formIntegration.inteSelected.usuario_condicional_status === 1 || formIntegration.inteSelected.usuario_condicional_status === '1'"
              >
                <option>Selecione</option>
                <option
                  v-for="user in usersPipe"
                  :key="user.id"
                  :value="user.id"
                >
                  {{ user.name }}
                </option>
              </select>
            </div>
            <div>
              <b-form-group label="Deseja habilita a opção de usuario condicional:">
                <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  v-b-tooltip.hover.right="'Caso selecionado sim, você poderá cadastrar usuarios com a condição que desejar.'"
                  variant="secondary"
                  size="sm"
                  style="margin-left: 335px;margin-top: -50px;"
                >?
                </b-button>
                <b-form-checkbox-group
                  v-model="formIntegration.inteSelected.usuario_condicional_status"
                  :checked="formIntegration.inteSelected.usuario_condicional_status"
                  value="1"
                  unchecked-value="0"
                  :options="[{ text: 'Sim', value: '1' }, { text: 'Não', value: '0' }]"
                />
              </b-form-group>
            </div>
            <div>
              <div
                v-show="formIntegration.inteSelected.usuario_condicional_status === 1 || formIntegration.inteSelected.usuario_condicional_status === '1'"
              >
                <b-form
                  ref="formUsuario"
                  :style="{height: trHeight}"
                  class="repeater-form"
                  @submit.prevent="repeateAgain"
                >
                  <b-row
                    v-for="(item, index) in formIntegration.usuario_condicional"
                    :id="item.id"
                    :key="item.id"
                    ref="row"
                  >
                    <b-col md="2">
                      <b-form-group
                        label="Variavel"
                        label-for="cost"
                      >
                        <v-select
                          v-model="item.variavel"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          label="label"
                          :options="variaveis1"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col md="2">
                      <b-form-group
                        label="Condição"
                        label-for="cost"
                      >
                        <v-select
                          v-model="item.condicao"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          label="title"
                          :options="condicao"
                          disabled
                        />
                      </b-form-group>
                    </b-col>
                    <b-col md="2">
                      <b-form-group
                        label="Valor"
                        label-for="quantity"
                      >
                        <v-select
                          v-model="item.valor"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          label="name"
                          :options=" item.variavel.options "
                        />
                      </b-form-group>
                    </b-col>
                    <b-col
                      v-if="item.valor != null && item.variavel != null && item.condicao != null"
                      md="4"
                    >
                      <b-form-group
                        label="Usuario"
                        label-for="quantity"
                      >

                        <v-select
                          v-model="item.usuario"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          label="name"
                          :options="usersPipe"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col
                      lg="2"
                      md="3"
                      class="mb-50"
                    >
                      <b-button
                        v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                        variant="outline-danger"
                        class="mt-0 mt-md-2"
                        @click="removeItem(index)"
                      >
                        <feather-icon
                          icon="XIcon"
                          class="mr-25"
                        />
                        <span>Excluir</span>
                      </b-button>
                    </b-col>
                    <b-col cols="12">
                      <hr>
                    </b-col>
                  </b-row>

                </b-form>
              </div>
              <div
                v-show="formIntegration.inteSelected.usuario_condicional_status === 1 || formIntegration.inteSelected.usuario_condicional_status === '1'"
                class="mt-2"
              >
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  @click="repeateAgain"
                >
                  <feather-icon
                    icon="PlusIcon"
                    class="mr-25"
                  />
                  <span>Novo</span>
                </b-button>
              </div>
            </div>
          </b-col>
        </b-row>
      </tab-content>
      <div
        v-if="loadingWizard"
        class="loader"
      />
    </form-wizard>

  </div>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'
import { heightTransition } from '@core/mixins/ui/transition'
import Ripple from 'vue-ripple-directive'
import Info from '@/views/App/Chat/Info.vue'
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput, BFormCheckboxGroup,
} from 'bootstrap-vue'
import { useApi } from '@/composables/useApi'

const apiBack = useApi()
export default {
  components: {
    BFormCheckboxGroup,
    FormWizard,
    TabContent,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    vSelect,
    Info,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  data() {
    return {
      items: [],
      dir: 'ltr',
      variaveis1: [],
      condicao: ['é'],
      option: [],
      nextTodoId: 2,
      chatsExistents: [],
      usersPipe: [],
      selectedUser: null,
      variaveis: [],
      isValid: true,
      loadingWizard: false,

    }
  },
  computed: {
    formIntegration: {
      get() {
        return this.$store.getters['AppChatbooster/GET_CURRENT_INTEGRATION']
      },
      set(newValue) {
        this.$store.commit('AppChatbooster/SET_CURRENT_INTEGRATION', newValue)
      },
    },

    getUserData() {
      return JSON.parse(localStorage.getItem('userData'))
    },
    isFormValid: {
      get() {
        return this.formIntegration.formPipedriveConfig.find(item => item.id === 'email').value === ''
      },
      set(value) {
        this.formIntegration.formPipedriveConfig.find(item => item.id === 'email').value = value
      },
    },
  },
  async mounted() {
    this.Listavariaveis()
    this.initTrHeight()

    if (this.formIntegration.inteSelected.id != null) {
      this.setOwnerID()
    }
    this.setLoading(true)
    await this.getAllChats()
    this.setLoading(false)
    await this.usersPipedrive()
  },
  created() {
    window.addEventListener('resize', this.initTrHeight)
  },
  destroyed() {
    window.removeEventListener('resize', this.initTrHeight)
  },
  methods: {

    Listavariaveis() {
      console.log('formIntegration', this.formIntegration)
      console.log('é', this.formIntegration)
      apiBack.get(`/getFluxoEXTByIdFluxoAndOptions/${this.formIntegration.chatSelected.id}`)
        .then(response => {
          console.log(response)
          const resposta = JSON.parse(JSON.stringify(response.data))
          this.variaveis1 = resposta
            .filter(valor => valor.type === 2)
            .map(valor => ({
              id: valor.id,
              label: valor.label,
              options: JSON.parse(valor.options),
            }))
          console.log(this.variaveis1)
        })
        .catch(error => {
          console.error(error)
        })
    },
    repeateAgain() {
      this.formIntegration.usuario_condicional.push({
        id: this.nextTodoId += this.nextTodoId,
        variavel: {},
        condicao: 'é',
        valor: null,
        usuario: '',
      })

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight)
      })
    },
    removeItem(index) {
      this.formIntegration.usuario_condicional.splice(index, 1)
      this.trTrimHeight(this.$refs.row[0].offsetHeight)
    },
    initTrHeight() {
      this.trSetHeight(null)
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.formUsuario.scrollHeight)
        console.log('altura', this.$refs.formUsuario.scrollHeight)
      })
    },
    setOwnerID() {
      this.selectedUser = this.$store.getters['AppChatbooster/GET_CURRENT_INTEGRATION']
        .formPipedriveConfig
        .find(item => item.id === 'owner_id').value
    },
    atualizarValue(value, form) {
      this.formIntegration.formPipedriveConfig.map(f => {
        if (f.id === form.id) {
          f.value = value.replace(/<[^>]*>/g, '')
        }
        return f
      })
    },
    async usersPipedrive() {
      try {
        const { data } = await apiBack.get(`/getUserPipedrive?id_user=${this.getUserData.id}`)
        console.log(data)

        // Filtra a lista de usuários pelo active_flag
        this.usersPipe = data.filter(user => user.active_flag)
      } catch (error) {
        console.error(error)
      }
    },

    resetFormIntegration() {
      this.$store.commit('AppChatbooster/RESET_INTEGRATION', {
        chatSelected: '',
        formPipedriveConfig: [
          { title: 'Nome do contato', id: 'name', value: '' },
          { title: 'Email do contato', id: 'email', value: '' },
          { title: 'Telefone do contato', id: 'phone', value: '' },
        ],
      })
      this.$store.commit('AppChatbooster/SET_CURRENT_TAB_INTEGRATION', 'integrations')
    },
    validateAsync() {
      return new Promise((resolve, reject) => {
        if (this.$refs.formWizard.activeTabIndex === 0 && this.formIntegration.chatSelected === '') {
          this.$refs.formWizard.activeTabIndex = 0
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Chat não pode ser vazio',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
          document.querySelector('.tinymce-heading-fluxo_form_rd_chat').focus()
          // eslint-disable-next-line prefer-promise-reject-errors
          reject(false)
          return false
        }
        if (this.$refs.formWizard.activeTabIndex === 1 && this.formIntegration.formPipedriveConfig.find(item => item.id === 'email').value === '') {
          this.$refs.formWizard.activeTabIndex = 1
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'E-mail não pode ser vazio',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
          document.querySelector('.tinymce-heading-fluxo_form_rd_email').focus()
          // eslint-disable-next-line prefer-promise-reject-errors
          reject(false)
          return false
        }
        this.Listavariaveis()
        this.setLoading(true)
        this.getAllVariaveis().then(() => {
          this.setLoading(false)
          resolve(true)
        })
        resolve(true)
        return true
      })
    },
    setLoading(value) {
      this.loadingWizard = value
    },
    changeTab() {
      console.log('changeTab')
    },
    async getAllChats() {
      await apiBack.get(`/chat/${this.getUserData.id}`)
        .then(data => {
          this.chatsExistents = data.data
        })
        .catch(err => console.error(err))
    },
    async formSubmitted() {
      document.querySelectorAll('.gatilho-selected').forEach(item => {
        item.classList.remove('gatilho-selected')
      })

      if (this.formIntegration.inteSelected.id != null) {
        this.formIntegration.formPipedriveConfig.map(item => {
          if (item.id === 'owner_id') {
            item.value = this.selectedUser
          }
          return item
        })
        await apiBack.put(`/Integracoes/${this.formIntegration.inteSelected.id}`, {
          modelo: 'Pipedrive',
          fluxos: this.formIntegration.chatSelected.name,
          eventos: 'lead::finish',
          id_user: this.getUserData.id,
          id_chat: this.formIntegration.chatSelected.id,
          modelo_metadata: JSON.stringify(this.formIntegration.formPipedriveConfig),
          usuario_condicional: JSON.stringify(this.formIntegration.usuario_condicional),
          usuario_condicional_status: this.formIntegration.inteSelected.usuario_condicional_status,
          url: '',
        })
          .then(() => {
            this.$message({
              type: 'success',
              message: 'Atualizado com sucesso',
            })
          })
          .catch(err => console.error(err))

        this.$refs.formWizard.reset()
        this.resetFormIntegration()
      } else {
        this.$store.dispatch('AppChatbooster/GET_INTEGRATION_DB')
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Integração criada com sucesso!',
            icon: 'EditIcon',
            variant: 'success',
          },

        })
        this.formIntegration.formPipedriveConfig.push({
          title: '',
          id: 'owner_id',
          value: this.selectedUser,
        })
        const formData = {
          modelo: 'Pipedrive',
          fluxos: this.formIntegration.chatSelected.name,
          eventos: 'lead:finish',
          id_user: this.getUserData.id,
          id_chat: this.formIntegration.chatSelected.id,
          modelo_metadata: JSON.stringify(this.formIntegration.formPipedriveConfig),
          usuario_condicional: JSON.stringify(this.formIntegration.usuario_condicional),
          usuario_condicional_status: this.formIntegration.inteSelected.usuario_condicional_status,
          owner_id: this.selectedUser,
        }
        this.$store.dispatch('AppChatbooster/SAVE_INTEGRATION_DB', formData)
        this.$refs.formWizard.reset()
        this.resetFormIntegration()
      }
    },
    async getAllVariaveis() {
      await this.$store.dispatch('AppChatbooster/GET_ACCESS_TOKEN_PIPEDRIVE')
      await apiBack.post('/getAllVariaveisByArray', {
        array: [this.formIntegration.chatSelected.id],
      })
        .then(data => {
          this.variaveis = JSON.parse(JSON.stringify(data.data))
        })
        .catch(err => console.error(err))
    },
  },
}
</script>

<style scoped lang="scss">
.gatilho-selected {
  border: 2px solid red;
  background: #ff000017;
}

/* This is a css loader. It's not related to vue-form-wizard */
.loader,
.loader:after {
  border-radius: 50%;
  width: 10em;
  height: 10em;
}

.loader {
  margin: 60px auto;
  font-size: 10px;
  position: relative;
  text-indent: -9999em;
  border-top: 1.1em solid rgba(255, 255, 255, 0.2);
  border-right: 1.1em solid rgba(255, 255, 255, 0.2);
  border-bottom: 1.1em solid rgba(255, 255, 255, 0.2);
  border-left: 1.1em solid #e74c3c;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: load8 1.1s infinite linear;
  animation: load8 1.1s infinite linear;
}

@-webkit-keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

</style>
